import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const HTTP_URL_REGEX = /^https?:\/\/.+/i;

// Anything else (notably "javascript:") assigned to window.location.href would run
// on our own domain instead of navigating, so redirect targets must be http(s).
export const isHttpUrl = (value?: string | null): boolean => !!value && HTTP_URL_REGEX.test(value.trim());

export const httpUrlValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;
  if (!value) {
    return null;
  }
  return isHttpUrl(value) ? null : { httpUrl: true };
};
